<app-training-tab
[confirmationMessage]="confirmationMessage"
[buttonLabel]="buttonLabel"
[trainingPlanDto]="trainingPlanDetails"
(update)="ifTakeQuiz? openQuiz() : updateTrainingPlan()"
[courseDetail]="courseDetail"
[disabled]="disabled"
[showQuiz]="showQuiz"
[quizDataToDisplay]="courseProficiencyQuiz"
[quizType]="quizType"
(reload) = "reloadCourseTraining()"></app-training-tab>